import React from "react"
import { Field, InjectedFormProps, reduxForm } from "redux-form"
import { SurveyModel } from "../../../../../rpcs/dist/ChatRoomRPC"
import Color from "../../../../../style/enum/color"
import { Scale } from "../../components/scale"
import { Buttons, StyledButton, SurveyWrapper } from "../components/styles"
import { TitleInput } from "../components/title-input"
import { validate } from "./validation"

export interface ICreateScaleSurveyProps {
  surveyModel: SurveyModel.Scale
  title: string
}

interface ICustomProps {
  onBack: () => void
}

const InitialValues: ICreateScaleSurveyProps = {
  surveyModel: SurveyModel.Scale,
  title: "",
}

const Form = (props: InjectedFormProps & ICustomProps) => {
  return (
    <SurveyWrapper>
      <form onSubmit={props.handleSubmit}>
        <Field name="surveyModel" type="hidden" component="input" />
        <Field
          name="title"
          type="text"
          component={TitleInput}
          placeholder="質問を入力してください"
        />
        <Scale />
        <Buttons>
          <StyledButton
            type="button"
            borderColor={Color.DIMGRAY}
            color={Color.DIMGRAY}
            onClick={props.onBack}
          >
            戻る
          </StyledButton>
          <StyledButton
            type="submit"
            backgroundColor={Color.BRAND}
            color={Color.WHITE}
          >
            送信
          </StyledButton>
        </Buttons>
      </form>
    </SurveyWrapper>
  )
}

export const CreateScaleSurvey = reduxForm<
  ICreateScaleSurveyProps,
  ICustomProps
>({
  form: "CreateScaleSurvey",
  validate,
  initialValues: InitialValues,
})(Form)
